export default {
	USDT: 'USDT',
	保存并下次使用: 'Save for future use',
	保存此卡以用于后续支付: 'Save this card for future payments',
	操作: 'Actions',
	操作失败: 'Operation failed',
	操作时间: 'Time',
	查看发票: 'View invoice',
	查看记录: 'View record',
	查看信用发票: 'Credit invoices',
	查看信用记录: 'Credit history',
	持卡人姓名: 'Cardholder name',
	充值记录: 'Recharge Log',
	充值金额: 'Recharge amount',
	充值提示: 'Please enter an integer between {min} and {max}',
	创建时间: 'Created time',
	打印: 'Print',
	打印时间: 'Printed at',
	到期: 'Expires',
	到期日期: 'Due date',
	订单编号: 'Order number',
	订单发票: 'Order Invoices',
	订单详情: 'Order details',
	订单支付: 'Order payment',
	发票编号: 'Invoice No.',
	发票项目: 'Line items',
	发票PDF: 'Invoice PDF',
	非常感谢您的付款已成功完成: 'Thank you for your payment. It has been successfully completed',
	复制链接: 'Copy link',
	复制失败: 'Copy failed',
	管理信用卡: 'Manage Cards',
	交易详情: 'Transaction',
	接收方: 'Invoice to',
	金额: 'Amount',
	金额已复制: 'Amount copied',
	进行实名认证: 'Verify Now',
	卡片保存成功: 'Card saved',
	可用余额: 'Available balance',
	类型: 'Type',
	立即充值: 'Recharge Now',
	链接已复制: 'Link copied',
	登录提醒: 'Sign in required',
	描述: 'Description',
	默认: 'Default',
	内容: 'Content',
	其它支付方式: 'Other payment methods (card, Alipay, WeChat, etc.)',
	请扫描二维码或点击金额和地址粘贴转账USDT支付:
		'Scan the QR code, or click the amount and address to copy them, and complete the transfer in USDT (TRC-20).',
	'请使用微信「扫一扫」': 'Scan the QR code with WeChat to pay',
	'请使用支付宝「扫一扫」': 'Scan the QR code with Alipay to pay',
	请输入持卡人姓名: 'Enter cardholder name',
	请输入发票编号: 'Enter invoice number',
	请先获取支付信息: 'Please fetch payment info first',
	请先登录后使用该支付方式: 'Please sign in to use this payment method',
	请先进行实名认证或提升实名认证等级: 'Please complete identity verification or upgrade your verification level first',
	确认删除此卡吗: 'Delete this card?',
	去登录: 'Sign in',
	删除此卡: 'Delete card',
	商品名称: 'Product name',
	设为自动扣款: 'Set as auto-pay',
	生成日期: 'Generated on',
	生成时间: 'Generated at',
	实名认证提醒: 'Identity Verification Required',
	使用浏览器打开支付页面: 'Open payment page in browser',
	使用新卡: 'Use new card',
	使用信用卡: 'Use card',
	使用已保存的卡: 'Use saved card',
	使用已保存的卡片: 'Use saved card',
	输入新卡支付: 'Use new card',
	拖动卡片进行排序: 'Drag cards to reorder',
	微信扫码支付: 'Scan the QR code with WeChat to pay',
	微信支付: 'WeChat',
	下载: 'Download',
	小计: 'Subtotal',
	新增信用卡: 'Add Card',
	信用发票: 'Credit invoice',
	信用记录: 'Credit record',
	信用卡: 'Card',
	信用余额: 'Credit balance',
	信用余额可用于后续平台的消费: 'Credit balance can be used for future purchases on the platform',
	选择支付方式: 'Choose payment method',
	已过期: 'Payment expired',
	应付金额: 'Amount payable',
	余额: 'Balance',
	余额不足: 'Insufficient balance. Please top up or choose another payment method',
	账号概况: 'Account overview',
	正在验证: 'Verifying...',
	支付: 'Pay',
	支付宝: 'Alipay',
	支付成功: 'Payment successful',
	支付初始化失败: 'Payment initialization failed',
	支付方式: 'Payment method',
	支付金额: 'Payment amount',
	支付日期: 'Paid on',
	支付失败: 'Payment failed',
	支付时间: 'Payment time',
	支付信息: 'Payment information',
	支付中: 'Processing...',
	支付ID: 'Payment ID',
	转账金额必须为下方显示带小数点的金额: 'The transfer amount must match the value shown below, including its decimal places.',
	转账金额必须为下方显示的金额且需要在倒计时内完成转账否则无法被系统确认:
		'The transfer amount must match the value shown below and the transfer must be completed within the countdown, otherwise the system cannot confirm it!',
	状态: 'Status',
	自定义: 'Custom',
	自动扣款: 'Auto-pay',
	自动扣款中: 'Auto-pay active',
	总计: 'Total',
	最低充值金额: 'Minimum top-up {amount}',
	USDT地址已复制: 'USDT address copied',
}
